/**
 * Copyright © Veeam Software Group GmbH.
 */

import { SlaPeriodRepresentation as SlaPeriodRepresentationModel } from '@veeam-vspc/models/web-controllers';

export type SlaPeriodRepresentation = SlaPeriodRepresentationModel;
export const SlaPeriodRepresentation = SlaPeriodRepresentationModel;
